module.exports = __webpack_public_path__ + "5a54c365069c2691ec683139e2f46628.jpg";